import { default as ProductReviewLogo } from '@oneflare/flarekit/lib/components/logos/ProductReview';
import StarRating from '@oneflare/flarekit/lib/components/StarRating';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

/**
 * This component displays the product review logo, rating and description.
 * The data is hardcoded for now by design.
 */
const ProductReview: React.FunctionComponent = () => {
  const rating = 4.5;
  const description = '(5,609+ Reviews)';

  return (
    <Container>
      <Column>
        <StyledProductReviewLogo />
      </Column>
      <Column $gap="sm">
        <Column $gap="xs">
          <StarRating
            maxRating={1}
            rating={1}
            starStyles={{
              xs: { size: '20px', spacing: '0px' }
            }}
          />
          <Label $bold>{rating}</Label>
        </Column>
        <Label>{description}</Label>
      </Column>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.md} 0;
  row-gap: ${({ theme }) => theme.spacing.sm};

  ${media.smUp`
    padding: ${({ theme }) => theme.spacing.lg} 0;
    flex-direction: row;
    column-gap: ${({ theme }) => theme.spacing.sm};
  `}
`;

const Column = styled.div<{ $gap?: string }>`
  display: flex;
  align-items: center;
  ${({ theme, $gap }) => $gap && `gap: ${theme.spacing[$gap]}`};
`;

const StyledProductReviewLogo = styled(ProductReviewLogo)`
  height: 25px;

  path {
    fill: ${({ theme }) => theme.color.charcoal};
  }

  ${media.smUp`
    margin-top: 4px;

    path {
      fill: ${({ theme }) => theme.color.white};
    }
  `}
`;

const Label = styled.label<{ $bold?: boolean }>`
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 16px;
  font-family: ${({ theme }) => theme.font.primaryRegular};
  font-weight: ${({ $bold }) => ($bold ? 700 : 400)};

  ${media.smUp`
    font-size: 18px;
    color: ${({ theme }) => theme.color.white};
  `}
`;

export { ProductReview };
